// src/components/PlaceholderLoader/PlaceholderLoader.js
import './PlaceholderLoader.css';

const PlaceholderLoader = ({ count = 2 }) => {
  const renderPlaceholderTabs = () => {
    const tabs = [];
    
    for (let i = 0; i < count; i++) {
      tabs.push(
        <div key={i} className="hvnly-placeholder-tab">
          <div className="hvnly-placeholder-tab-header">
            <div className="hvnly-placeholder-tab-icon"></div>
            <div className="hvnly-placeholder-tab-title"></div>
            <div className="hvnly-placeholder-tab-actions">
              <div className="hvnly-placeholder-action"></div>
              <div className="hvnly-placeholder-action"></div>
            </div>
          </div>
          <div className="hvnly-placeholder-tab-content">
            <div className="hvnly-placeholder-field">
              <div className="hvnly-placeholder-field-header">
                <div className="hvnly-placeholder-field-label"></div>
                <div className="hvnly-placeholder-field-actions">
                  <div className="hvnly-placeholder-field-action"></div>
                  <div className="hvnly-placeholder-field-action"></div>
                  <div className="hvnly-placeholder-field-action"></div>
                </div>
              </div>
              <div className="hvnly-placeholder-field-input"></div>
            </div>
            <div className="hvnly-placeholder-field">
              <div className="hvnly-placeholder-field-header">
                <div className="hvnly-placeholder-field-label"></div>
                <div className="hvnly-placeholder-field-actions">
                  <div className="hvnly-placeholder-field-action"></div>
                  <div className="hvnly-placeholder-field-action"></div>
                  <div className="hvnly-placeholder-field-action"></div>
                </div>
              </div>
              <div className="hvnly-placeholder-field-input medium"></div>
            </div>
            <div className="hvnly-placeholder-field">
              <div className="hvnly-placeholder-field-header">
                <div className="hvnly-placeholder-field-label"></div>
                <div className="hvnly-placeholder-field-actions">
                  <div className="hvnly-placeholder-field-action"></div>
                  <div className="hvnly-placeholder-field-action"></div>
                  <div className="hvnly-placeholder-field-action"></div>
                </div>
              </div>
              <div className="hvnly-placeholder-field-input short"></div>
            </div>
          </div>
        </div>
      );
    }
    
    return tabs;
  };

  return (
    <div className="hvnly-placeholder-loader">
      {renderPlaceholderTabs()}
    </div>
  );
};

export default PlaceholderLoader;